import { parseCsvFile } from './parseCsv';
import { parseExcelFile } from './parseExcel';
import { parsePdfFile } from './parsePdf';
import { ImportParseResult } from './types';

export type { ImportRow, ImportParseResult } from './types';
export {
  makeImportId,
  monthKeyFromDate,
  monthLabel,
  isDuplicateTransaction,
} from './types';

export async function parseImportFile(file: File): Promise<ImportParseResult> {
  const name = file.name.toLowerCase();
  if (name.endsWith('.csv') || file.type === 'text/csv') {
    return parseCsvFile(file);
  }
  if (
    name.endsWith('.xlsx') ||
    name.endsWith('.xls') ||
    file.type.includes('spreadsheet') ||
    file.type.includes('excel')
  ) {
    return parseExcelFile(file);
  }
  if (name.endsWith('.pdf') || file.type === 'application/pdf') {
    return parsePdfFile(file);
  }
  throw new Error('Unsupported file type. Please upload PDF, CSV, or Excel (.xlsx).');
}
